import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

const RouteChangeTracker = () => {
    const location = useLocation();

    useEffect(() => {
        // This sends a "pageview" event to Google Analytics
        // every time the user navigates to a new page
        ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
    }, [location]); // The effect runs every time the `location` object changes

    // This component renders nothing to the screen
    return null; 
};

export default RouteChangeTracker;